import RouteView from '../../router/RouteView.vue';

import CourseDistribution from './index.vue'; // 课程分销数据

import GoodsBuyStatistics from './goodsBuyStatistics.vue'; // 购买统计
import GoodsTimeStatistics from './goodsTimeStatistics.vue'; // 耗课统计

export default [
  {
    path: '/courseDistribution',
    name: 'courseDistribution',
    component: CourseDistribution,
    meta: {
      title: '课程分销数据',
    },
  },
  {
    path: '/courseDistribution',
    component: RouteView,
    meta: {
      title: '课程分销数据',
    },
    children: [
      {
        path: '/courseDistribution/buyStatistics',
        name: 'GoodsBuyStatistics',
        component: GoodsBuyStatistics,
        meta: {
          title: '购买统计',
        },
      },
      {
        path: '/courseDistribution/timeStatistics',
        name: 'GoodsTimeStatistics',
        component: GoodsTimeStatistics,
        meta: {
          title: '耗课统计',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/CourseDistribution/router.js